import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { H5 } from 'foundations-components/transitional/components/H5';
import { LoadingOverlay } from 'foundations-components/transitional/components/LoadingOverlay';
import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { objectTypes } from '../../../constants/types';
import { AppContext } from '../../../contexts/app/context';
import { ContactsPropsContext } from '../../../contexts/contacts/PropsContext';
import { ContactsContext } from '../../../contexts/contacts/context';
import { PropertiesContext } from '../../../contexts/properties/context';
import captureException from '../../../utils/captureException';
import { buildContactListFilters, transformContacts } from '../../../utils/contacts';
import { parseStringifiedObject } from '../../../utils/general';
import { buildSearchData } from '../../../utils/helpers';
import ContactSearch from '../../common/ContactSearch';
import SuggestionsListSection from '../SuggestionsListSection';
import { MapExistingContactTabContainer } from './MapExistingContactTab.style';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function MapExistingContactTab() {
  const {
    apiWrapper
  } = useContext(ContactsPropsContext);
  const {
    properties
  } = useContext(PropertiesContext);
  const {
    contactToAssociate,
    participantToAssociate,
    contactsActions
  } = useContext(ContactsContext);
  const {
    appName
  } = useContext(AppContext);
  const [isLoading, setIsLoading] = useState(false);
  const [contacts, setContacts] = useState([]);
  const lastSearchedQuery = useRef('');
  const defaultSearchValue = useMemo(() => participantToAssociate.email || participantToAssociate.name || '', [participantToAssociate]);
  const selectContact = contact => {
    if (typeof contact === 'string') {
      const parsedContact = parseStringifiedObject(contact);
      contactsActions.setContactToAssociate(parsedContact);
    } else {
      contactsActions.setContactToAssociate(contact);
    }
  };
  useEffect(() => {
    if (lastSearchedQuery.current !== defaultSearchValue) {
      lastSearchedQuery.current = defaultSearchValue;
      setIsLoading(true);
      const filters = buildContactListFilters();
      apiWrapper.searchObject(Object.assign({}, buildSearchData('0', filters, defaultSearchValue || '', properties.contact.defaultSidebarProperties), {
        objectType: objectTypes.contacts
      })).then(response => {
        setContacts(transformContacts(response.results));
      }).catch(captureException).finally(() => {
        setIsLoading(false);
      });
    }
  }, [apiWrapper, defaultSearchValue, properties.contact.defaultSidebarProperties]);
  if (isLoading) {
    return /*#__PURE__*/_jsx(LoadingOverlay, {
      contextual: true,
      size: "md"
    });
  }
  return /*#__PURE__*/_jsxs(MapExistingContactTabContainer, {
    children: [/*#__PURE__*/_jsx(SuggestionsListSection, {
      contacts: contacts,
      contactToAssociate: contactToAssociate,
      selectContact: selectContact,
      defaultSearchValue: defaultSearchValue,
      appName: appName
    }), /*#__PURE__*/_jsx(H5, {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: `associationsPanel.tabs.associate.manualSearch${contacts.length ? '' : 'NoResults'}`
      })
    }), /*#__PURE__*/_jsx(ContactSearch, {
      selectContact: selectContact,
      appName: appName,
      searchObjectApi: apiWrapper.searchObject
    })]
  });
}
export default MapExistingContactTab;